import script from "./NewsFlowChart.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsFlowChart.vue?vue&type=script&setup=true&lang=js"

import "./NewsFlowChart.vue?vue&type=style&index=0&id=5b115bd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b115bd0"]])

export default __exports__